/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import IconCookieScanner from '../../assets/Images/icons/icon-cookie-scanner';
import IconScanner from '../../assets/Images/icons/icon-scanner';
import { Button, Form, Select } from 'antd';
import styled from 'styled-components';
import CookieScannerService from '../../services/CookieScanner.service';
import IconScanNotFound from '../../assets/Images/icons/icon-scan-not-found';
import GlobalService from '../../services/Global.service';
import { ROUTER } from '../../constants/router';
import UserService from '../../services/UserService';
import UserManagementService from '../../services/UserManagement.service';
import MyCompanyService from '../../services/MyCompany.service';
import usePermission from '../../hooks/usePermission';

export default function CookieScanner() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const [form] = Form.useForm();
    const { Option } = Select;

    const [isButtonHidden, setIsButtonHidden] = useState(true);
    const [scan, setScan] = useState(false);
    const [isScanner, setIsScanner] = useState(true);
    const [domainList, setDomainList] = useState([]);

    const onFinish = async (value) => {
        try {
            setScan(true);
            const { data } = await CookieScannerService.getCookieScanning(
                `${findDomainName(domainList, value.DomainURL).domainName}`
            );
            if (data) {
                await getImage(data, data?.screenshot, value.DomainURL);
            }
        } catch (error) {
            setTimeout(async () => {
                setIsScanner(false);
            }, 2000);
            console.log(error);
        }
    };

    const importCookieScanner = async (res, domainImageId, domainID) => {
        let option = [];
        res?.cookies?.forEach((_data) => {
            option.push({
                name: _data.name || null,
                category: _data.category || null,
                description: _data.description || null,
                retention: _data.retention || null,
                domain: _data.domain || null,
                expires: Math.floor(_data.expires) || null,
            });
        });
        const payload = {
            domainImageId: domainImageId,
            domainId: domainID,
            url: res.url,
            necessary: res.categories?.Necessary,
            analytics: res.categories?.Analytics,
            marketing: res.categories?.Marketing,
            unclassified: res.categories?.Unclassified,
            scanDate: res.scanDate,
            cookies: option,
        };
        try {
            const { data } = await CookieScannerService.importCookieScanner(
                payload
            );
            if (data?.resultCode === 1) {
                if (data?.resultData) {
                    setTimeout(async () => {
                        await Navigate(data?.resultData?.domainId);
                    }, 1000);
                }
            } else {
                setTimeout(async () => {
                    setIsScanner(false);
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            setTimeout(async () => {
                setIsScanner(false);
            }, 2000);
        }
    };

    const getImage = async (res, imageSrc, domainID) => {
        function dataURLtoFile(dataurl, filename) {
            let arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, { type: mime });
        }
        //Usage example:
        let file = await dataURLtoFile(imageSrc, 'screenshot-scanner.jpeg');
        if (imageSrc) {
            // const blob = await fetch(imageSrc).then((res) => res.blob());
            const formData = new FormData();
            formData.append('image', file);
            formData.append('fileName', file.name);
            formData.append('action', 'image-create-application');
            try {
                const { data } = await GlobalService.uploadImage(formData);
                if (data) {
                    importCookieScanner(
                        res,
                        data?.resultData?.imageId,
                        domainID
                    );
                }
            } catch (error) {
                console.log(error);
                importCookieScanner(res, '', domainID);
            }
        } else {
            importCookieScanner(res, '', domainID);
        }
    };

    const Navigate = async (domainId) => {
        navigate(
            `${ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER}/report/${domainId}`
        );
    };
    const onChange = async () => {
        setIsButtonHidden(false);
    };

    const userId = UserService.getUi();

    useEffect(() => {
        const getDomainList = async (companyId) => {
            let ObjectSearch = {};
            ObjectSearch = {
                companyId: companyId,
                p: 1,
                ps: 10000,
                s: 'domainName',
                sd: 'ASC',
            };
            try {
                const { data } = await MyCompanyService.getDomainList(
                    ObjectSearch
                );
                const item = data?.resultData;
                setDomainList(item?.result?.filter((e) => e !== null) || []);
            } catch (err) {
                console.log(err);
            }
        };
        const getUserDetail = async () => {
            try {
                const { data } = await UserManagementService.getUserDetail(
                    userId
                );
                const item = data?.resultData;
                if (item?.companyId) {
                    getDomainList(item?.companyId);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getUserDetail();
    }, []);

    const findDomainName = (array, domainId) => {
        return array.find((element) => {
            return element.domainId === domainId;
        });
    };

    const { isAuditor, isUser } = usePermission();

    return (
        <>
            <div className="title ">{t('common.CookieScanner')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Cookie Management')} /
                </span>
                <span> {t('common.CookieScanner')} </span>
            </div>

            <div className="bg-white rounded-xl px-14 py-8 my-4 col-span-2">
                <div className="flex justify-center">
                    <div></div>
                    <div className="p-24 h-5/6">
                        {!scan ? (
                            <>
                                <div className="text-center">
                                    <IconCookieScanner />
                                </div>
                                <div className="mt-10 mb-10">
                                    <div className="title text-left">
                                        {t('common.CookieScanner')}
                                    </div>
                                    <div className="sub-title">
                                        <span className="text-sm">
                                            {t('COOKIE.CheckIfYourDomain')}
                                        </span>
                                    </div>
                                </div>
                                <Form
                                    scrollToFirstError={{
                                        behavior: 'smooth',
                                        block: 'center',
                                    }}
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                >
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('COOKIE.DomainURL')}
                                            </span>
                                        }
                                        className="initial"
                                        name="DomainURL"
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t(
                                                'COOKIE.PleaseSelectDomainURL'
                                            )}
                                            onChange={onChange}
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                (option?.children ?? '')
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    )
                                            }
                                        >
                                            {domainList?.map((e) => (
                                                <Option
                                                    size="large"
                                                    key={e?.domainId}
                                                    value={e?.domainId}
                                                >
                                                    {e?.domainName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <div
                                        hidden={isAuditor || isUser}
                                        className="flex justify-start space-x-3 pt-4"
                                    >
                                        <div>
                                            <Button
                                                className="w-[140px]"
                                                htmlType="submit"
                                                size="large"
                                                type="primary"
                                                disabled={isButtonHidden}
                                            >
                                                {t('COOKIE.ScanNow')}
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            </>
                        ) : (
                            <>
                                {isScanner ? (
                                    <div className="text-center py-10">
                                        <IconScanner />
                                        <Loading>
                                            <div className="loader">
                                                {t('Loading')}...
                                            </div>
                                        </Loading>
                                        <div className="title text-[24px] mt-4 mb-4">
                                            {t('COOKIE.ScanningInProcess')}
                                        </div>
                                        <div className="text-[17px] text-[#B3B2B2]">
                                            {t('COOKIE.ScaningNowPleaseWait')}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center py-8">
                                        <IconScanNotFound />
                                        <div className="title text-[24px] mt-2 mb-2">
                                            {t('COOKIE.ThisURLNotFound')}
                                        </div>
                                        <div className="text-[17px] text-[#B3B2B2]">
                                            {t('COOKIE.BackToScan')}
                                        </div>
                                        <div className="mt-4">
                                            <Button
                                                className="w-[140px]"
                                                size="large"
                                                type="primary"
                                                onClick={() => {
                                                    setScan(false);
                                                    setIsScanner(true);
                                                    form.resetFields();
                                                    setIsButtonHidden(true);
                                                }}
                                            >
                                                {t('common.Back')}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    );
}
const Loading = styled.div`
    .loader,
    .loader:before,
    .loader:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation: load7 1.8s infinite ease-in-out;
        animation: load7 1.8s infinite ease-in-out;
    }
    .loader {
        color: #7b67fb;
        font-size: 3px;
        margin: 10px auto;
        position: relative;
        text-indent: -9999em;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }
    .loader:before,
    .loader:after {
        content: '';
        position: absolute;
        top: 0;
    }
    .loader:before {
        left: -3.5em;
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }
    .loader:after {
        left: 3.5em;
    }
    @-webkit-keyframes load7 {
        0%,
        80%,
        100% {
            box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
            box-shadow: 0 2.5em 0 0;
        }
    }
    @keyframes load7 {
        0%,
        80%,
        100% {
            box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
            box-shadow: 0 2.5em 0 0;
        }
    }
`;
